import React from 'react'
import DatePicker from 'react-datepicker'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import ReactToPrint from 'react-to-print'
import * as route from '~/helper/constant/route'
import { Header } from '../../../../../components/header/header'
import { Loading } from '../../../../../components/loader/loader'
import { Sidebar } from '../../../../../components/sidebar/sidebar'
import { convertADtoBS } from '../../../../../helper/function/abstract'
import { AbstractProfitLossComponent, mapStateToProps } from './abstract'
class ProfitLossComponent extends AbstractProfitLossComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this._setYear = this._setYear.bind(this)
    }
    _setYear(data) {
        this.setState(
            {
                year: data,
            },
            () => {
                this._onSearch()
            }
        )
    }

    getRevenue() {
        const data = this.state.revenueList.map((item) => {
            return (
                <tr className="invoice_table_border">
                    <td>{item.category}</td>
                    {item.amount.map((amount) => {
                        return (
                            <td>
                                <small>{this.props.school.currency}</small>
                                &nbsp;
                                {parseFloat(amount).toFixed(2)}
                            </td>
                        )
                    })}
                </tr>
            )
        })
        return data
    }

    getInvoice() {
        if (this.state.invoiceList.length > 0) {
            const data = this.state.invoiceList.map((item) => {
                return (
                    <tr className="invoice_table_border">
                        <td>{item.category}</td>
                        {item.amount.map((amount) => {
                            return (
                                <td>
                                    <small>{this.props.school.currency}</small>
                                    &nbsp;
                                    {parseFloat(amount).toFixed(2)}
                                </td>
                            )
                        })}
                    </tr>
                )
            })
            return data
        } else {
            return (
                <tr className="invoice_table_border">
                    <td colSpan={13} className="text-center">
                        No data available
                    </td>
                </tr>
            )
        }
    }

    getExpense() {
        const data = this.state.expenseList.map((item) => {
            return (
                <tr className="invoice_table_border">
                    <td>{item.category}</td>
                    {item.amount.map((amount) => {
                        return (
                            <td>
                                <small>{this.props.school.currency}</small>
                                &nbsp;
                                {parseFloat(amount).toFixed(2)}
                            </td>
                        )
                    })}
                </tr>
            )
        })
        return data
    }

    getBill() {
        if (this.state.billList.length > 0) {
            const data = this.state.billList.map((item) => {
                return (
                    <tr className="invoice_table_border">
                        <td>{item.category}</td>
                        {item.amount.map((amount) => {
                            return (
                                <td>
                                    <small>{this.props.school.currency}</small>
                                    &nbsp;
                                    {parseFloat(amount).toFixed(2)}
                                </td>
                            )
                        })}
                    </tr>
                )
            })
            return data
        } else {
            return (
                <tr className="invoice_table_border">
                    <td colSpan={13} className="text-center">
                        No data available
                    </td>
                </tr>
            )
        }
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Sidebar id="report_accounting" isAccount={true} />
                <Loading status={this.state.loading} text="Loading" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; &nbsp;</a>
                            </li>
                            <li>
                                <a href={route.admin.accounting.reports.menu}>
                                    {t('reports:reports')} &nbsp; &gt; &nbsp;
                                </a>
                            </li>
                            <li>{t('reports:profitloss')}</li>
                        </ul>
                        <div className="row clearfix ">
                            <div className="col-md-8 float-left">
                                <h5 className="main-title heading5">{t('reports:profitloss')}</h5>
                            </div>
                            <div className="col-md-4 calendar-module text-right">
                                <div className="display-inline-block">
                                    <ReactToPrint
                                        documentTitle={this.props.school.short_code + '-' + t('reports:profitloss')}
                                        trigger={() => <a className="main-button">{t('activity:print')}</a>}
                                        content={() => this.ref}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main-form">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="timetable-form mb-5">
                                    <div className="row clearfix ">
                                        <div className="col-md-9"></div>
                                        <div className="col-md-3 header-filter">
                                            <label className="table-form-title">{t('reports:selectyear')} :</label>
                                            <DatePicker
                                                placeholderText={t('reports:selectyear')}
                                                dateFormat="yyyy"
                                                className="form-control"
                                                defaultValue={this.state.year}
                                                selected={this.state.year}
                                                onChange={this._setYear}
                                                showYearPicker={true}
                                            />
                                            {this.props.school != null && this.props.school.date_format == 'BS' && (
                                                <label className="date-bs">
                                                    {this.state.year != ''
                                                        ? convertADtoBS(this.state.year) != null
                                                            ? convertADtoBS(this.state.year).slice(0, -6) + ' BS'
                                                            : 'Invalid Date Range'
                                                        : ''}
                                                </label>
                                            )}
                                            {this.state.errors.year && (
                                                <label className="error text-danger">{this.state.errors.year}</label>
                                            )}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-lg-12 display-inline-block top-select-leaderboard">
                                            <div className="table-responsive">
                                                <table
                                                    className="table invoice_table"
                                                    ref={(div) => {
                                                        this.ref = div
                                                    }}
                                                >
                                                    <tbody>
                                                        <tr className="invoice_table_border">
                                                            <td colSpan={6} className="text-center">
                                                                <div className="invoice-image">
                                                                    <img src={this.props.school.profile} />
                                                                </div>
                                                                <div className="invoice-title">
                                                                    {this.props.school.name}
                                                                </div>
                                                                <div className="invoice-sub-title">
                                                                    {t('reports:profitloss')}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr className="invoice_table_border">
                                                            <td colSpan={6} className="text-right">
                                                                <div className="invoice_detail">
                                                                    <strong>{t('gamification:duration')} : </strong>
                                                                    <br />
                                                                    {this.state.duration}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr className="invoice_table_header_dark">
                                                            <td colSpan={6}>
                                                                <strong>{t('income:income')}</strong>
                                                            </td>
                                                        </tr>
                                                        <tr className="invoice_table_header_light">
                                                            <td>{t('alumni:category')}</td>
                                                            {this.state.monthList.map((item) => {
                                                                return <td>{item}</td>
                                                            })}
                                                        </tr>
                                                        {/* <tr className="invoice_table_border">
                                                            <td colSpan={6}>
                                                                <strong>{t('income:revenue')}</strong>
                                                            </td>
                                                        </tr>
                                                        {this.getRevenue()}
                                                        <tr className="invoice_table_border">
                                                            <td colSpan={6}>
                                                                <strong>{t('income:invoice')}</strong>
                                                            </td>
                                                        </tr> */}
                                                        {this.getInvoice()}
                                                        <tr className="invoice_table_header_light">
                                                            <td>
                                                                {t('fee:total')} {t('income:income')}
                                                            </td>
                                                            {this.state.totalIncome.map((item) => {
                                                                return (
                                                                    <td>
                                                                        <strong>
                                                                            <small>{this.props.school.currency}</small>
                                                                            &nbsp;
                                                                            {parseFloat(item).toFixed(2)}
                                                                        </strong>
                                                                    </td>
                                                                )
                                                            })}
                                                        </tr>
                                                        <tr className="invoice_table_header_dark">
                                                            <td colSpan={6}>
                                                                <strong>{t('accounting:expense')}</strong>
                                                            </td>
                                                        </tr>
                                                        <tr className="invoice_table_header_light">
                                                            <td>{t('alumni:category')}</td>
                                                            {this.state.monthList.map((item) => {
                                                                return <td>{item}</td>
                                                            })}
                                                        </tr>
                                                        {/* <tr className="invoice_table_border">
                                                            <td colSpan={6}>
                                                                <strong>{t('accounting:payment')}</strong>
                                                            </td>
                                                        </tr>
                                                        {this.getExpense()}
                                                        <tr className="invoice_table_border">
                                                            <td colSpan={6}>
                                                                <strong>{t('accounting:bill')}</strong>
                                                            </td>
                                                        </tr> */}
                                                        {this.getBill()}
                                                        <tr className="invoice_table_header_light">
                                                            <td>
                                                                {t('fee:total')} {t('accounting:expense')}
                                                            </td>
                                                            {this.state.totalExpense.map((item) => {
                                                                return (
                                                                    <td>
                                                                        <strong>
                                                                            <small>{this.props.school.currency}</small>
                                                                            &nbsp;
                                                                            {parseFloat(item).toFixed(2)}
                                                                        </strong>
                                                                    </td>
                                                                )
                                                            })}
                                                        </tr>
                                                        <tr className="invoice_table_header_dark">
                                                            <td>
                                                                <strong>{t('reports:netProfit')}</strong>
                                                            </td>
                                                            {this.state.netProfitList.map((item) => {
                                                                return (
                                                                    <td className={item < 0 ? 'negative-amount' : ''}>
                                                                        <strong>
                                                                            <small>{this.props.school.currency}</small>
                                                                            &nbsp;
                                                                            {item < 0
                                                                                ? parseFloat(item * -1).toFixed(2)
                                                                                : parseFloat(item).toFixed(2)}
                                                                        </strong>
                                                                    </td>
                                                                )
                                                            })}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const ProfitLoss = withTranslation()(connect(mapStateToProps)(ProfitLossComponent))

export { ProfitLoss }
